import { jsx as m, jsxs as w, Fragment as N } from "react/jsx-runtime";
import $, { useId as de, isValidElement as me, cloneElement as be } from "react";
import { c as C } from "./clsx-OuTLNxxd.js";
import { T as _e } from "./Tooltip-C5FFEkgJ.js";
var M = { exports: {} }, o = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var z;
function ye() {
  if (z) return o;
  z = 1;
  var l = Symbol.for("react.element"), i = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), h = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), E;
  E = Symbol.for("react.module.reference");
  function _(e) {
    if (typeof e == "object" && e !== null) {
      var v = e.$$typeof;
      switch (v) {
        case l:
          switch (e = e.type, e) {
            case a:
            case f:
            case c:
            case y:
            case x:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case h:
                case u:
                case d:
                case g:
                case b:
                case s:
                  return e;
                default:
                  return v;
              }
          }
        case i:
          return v;
      }
    }
  }
  return o.ContextConsumer = u, o.ContextProvider = s, o.Element = l, o.ForwardRef = d, o.Fragment = a, o.Lazy = g, o.Memo = b, o.Portal = i, o.Profiler = f, o.StrictMode = c, o.Suspense = y, o.SuspenseList = x, o.isAsyncMode = function() {
    return !1;
  }, o.isConcurrentMode = function() {
    return !1;
  }, o.isContextConsumer = function(e) {
    return _(e) === u;
  }, o.isContextProvider = function(e) {
    return _(e) === s;
  }, o.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === l;
  }, o.isForwardRef = function(e) {
    return _(e) === d;
  }, o.isFragment = function(e) {
    return _(e) === a;
  }, o.isLazy = function(e) {
    return _(e) === g;
  }, o.isMemo = function(e) {
    return _(e) === b;
  }, o.isPortal = function(e) {
    return _(e) === i;
  }, o.isProfiler = function(e) {
    return _(e) === f;
  }, o.isStrictMode = function(e) {
    return _(e) === c;
  }, o.isSuspense = function(e) {
    return _(e) === y;
  }, o.isSuspenseList = function(e) {
    return _(e) === x;
  }, o.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === a || e === f || e === c || e === y || e === x || e === R || typeof e == "object" && e !== null && (e.$$typeof === g || e.$$typeof === b || e.$$typeof === s || e.$$typeof === u || e.$$typeof === d || e.$$typeof === E || e.getModuleId !== void 0);
  }, o.typeOf = _, o;
}
var r = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I;
function xe() {
  return I || (I = 1, process.env.NODE_ENV !== "production" && function() {
    var l = Symbol.for("react.element"), i = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), h = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), E = !1, _ = !1, e = !1, v = !1, L = !1, H;
    H = Symbol.for("react.module.reference");
    function B(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === f || L || t === c || t === y || t === x || v || t === R || E || _ || e || typeof t == "object" && t !== null && (t.$$typeof === g || t.$$typeof === b || t.$$typeof === s || t.$$typeof === u || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === H || t.getModuleId !== void 0));
    }
    function p(t) {
      if (typeof t == "object" && t !== null) {
        var P = t.$$typeof;
        switch (P) {
          case l:
            var T = t.type;
            switch (T) {
              case a:
              case f:
              case c:
              case y:
              case x:
                return T;
              default:
                var F = T && T.$$typeof;
                switch (F) {
                  case h:
                  case u:
                  case d:
                  case g:
                  case b:
                  case s:
                    return F;
                  default:
                    return P;
                }
            }
          case i:
            return P;
        }
      }
    }
    var O = u, Y = s, D = l, V = d, j = a, G = g, k = b, q = i, U = f, X = c, Z = y, J = x, W = !1, A = !1;
    function K(t) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(t) {
      return A || (A = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ee(t) {
      return p(t) === u;
    }
    function te(t) {
      return p(t) === s;
    }
    function oe(t) {
      return typeof t == "object" && t !== null && t.$$typeof === l;
    }
    function re(t) {
      return p(t) === d;
    }
    function ne(t) {
      return p(t) === a;
    }
    function le(t) {
      return p(t) === g;
    }
    function ie(t) {
      return p(t) === b;
    }
    function ae(t) {
      return p(t) === i;
    }
    function se(t) {
      return p(t) === f;
    }
    function ce(t) {
      return p(t) === c;
    }
    function fe(t) {
      return p(t) === y;
    }
    function ue(t) {
      return p(t) === x;
    }
    r.ContextConsumer = O, r.ContextProvider = Y, r.Element = D, r.ForwardRef = V, r.Fragment = j, r.Lazy = G, r.Memo = k, r.Portal = q, r.Profiler = U, r.StrictMode = X, r.Suspense = Z, r.SuspenseList = J, r.isAsyncMode = K, r.isConcurrentMode = Q, r.isContextConsumer = ee, r.isContextProvider = te, r.isElement = oe, r.isForwardRef = re, r.isFragment = ne, r.isLazy = le, r.isMemo = ie, r.isPortal = ae, r.isProfiler = se, r.isStrictMode = ce, r.isSuspense = fe, r.isSuspenseList = ue, r.isValidElementType = B, r.typeOf = p;
  }()), r;
}
process.env.NODE_ENV === "production" ? M.exports = ye() : M.exports = xe();
var he = M.exports;
const pe = "320px", ge = "600px", Ce = "1025px", Se = "_isVisuallyHidden_13l36_51", ve = "_grid_13l36_63", Ee = "_table_13l36_73", Te = "_tableCaption_13l36_77", Re = "_tableHeader_13l36_80", Pe = "_tableBody_13l36_77", we = "_tableGroup_13l36_127", Me = "_tableLabel_13l36_137", $e = "_tableRow_13l36_185", He = "_tableColumn_13l36_194", We = "_highlight_13l36_203", Ae = "_tableFooter_13l36_230", Fe = "_TableRow_13l36_235", Ne = "_TableCell_13l36_235", ze = "_tableCell_13l36_244", Ie = "_fullWidthMobile_13l36_251", Le = "_showDividers_13l36_270", Be = "_cellWrapper_13l36_309", Oe = "_headingText_13l36_200", Ye = "_columnWrapper_13l36_312", De = "_mainColumn_13l36_377", n = {
  mobile: pe,
  "mobile-wide": "480px",
  tablet: ge,
  "tablet-wide": "800px",
  desktop: Ce,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: Se,
  grid: ve,
  table: Ee,
  tableCaption: Te,
  "tableBody--additional": "_tableBody--additional_13l36_77",
  tableHeader: Re,
  tableBody: Pe,
  tableGroup: we,
  tableLabel: Me,
  tableRow: $e,
  tableColumn: He,
  "headingText--mobile": "_headingText--mobile_13l36_200",
  highlight: We,
  tableFooter: Ae,
  TableRow: Fe,
  TableCell: Ne,
  tableCell: ze,
  fullWidthMobile: Ie,
  showDividers: Le,
  "highlight--green": "_highlight--green_13l36_288",
  "highlight--amber": "_highlight--amber_13l36_292",
  "highlight--red": "_highlight--red_13l36_296",
  "mobile-hide": "_mobile-hide_13l36_300",
  cellWrapper: Be,
  headingText: Oe,
  columnWrapper: Ye,
  mainColumn: De
}, Ve = ({
  children: l,
  className: i,
  ...a
}) => /* @__PURE__ */ m("thead", { className: C(i, n.tableHeader), ...a, children: l }), je = ({
  children: l,
  className: i,
  isAdditionalContent: a,
  ...c
}) => /* @__PURE__ */ m(
  "tbody",
  {
    className: C(i, n.tableBody, {
      [n["tableBody--additional"]]: a
    }),
    ...c,
    children: l
  }
), Ge = ({
  children: l,
  className: i,
  ...a
}) => /* @__PURE__ */ m("tfoot", { className: C(i, n.tableFooter), ...a, children: l }), ke = ({
  children: l,
  className: i,
  ...a
}) => /* @__PURE__ */ m(
  "tr",
  {
    style: {
      "--columns": $.Children.count(l)
    },
    className: C(n.tableRow, i),
    ...a,
    children: l
  }
), qe = ({
  children: l,
  className: i
}) => /* @__PURE__ */ m("caption", { className: C(n.tableCaption, i), children: l }), Ue = ({
  alignItems: l = "center",
  children: i,
  className: a,
  highlight: c,
  isMain: f,
  justifyContent: s = "flex-start",
  mobileView: u,
  mobileText: h,
  span: d = 1,
  showDividers: y,
  toolTipSide: x,
  tooltipText: b
}) => /* @__PURE__ */ m(
  "th",
  {
    className: C(
      n.tableColumn,
      n[`mobile-${u}`],
      {
        [n.mainColumn]: f,
        [n.highlight]: c,
        [n.span]: d,
        [n.showDividers]: y
      },
      a
    ),
    style: {
      "--span": d
    },
    children: /* @__PURE__ */ w(
      "div",
      {
        className: n.columnWrapper,
        style: {
          "--alignItems": l,
          "--justifyContent": s
        },
        children: [
          h ? /* @__PURE__ */ w(N, { children: [
            /* @__PURE__ */ m("span", { className: n["headingText--mobile"], children: h }),
            /* @__PURE__ */ m("span", { className: n.headingText, children: i })
          ] }) : /* @__PURE__ */ m(N, { children: i }),
          b && /* @__PURE__ */ m(_e, { side: x, children: b })
        ]
      }
    )
  }
), Xe = ({
  alignItems: l = "center",
  children: i,
  highlight: a,
  isMain: c = !1,
  justifyContent: f = "flex-start",
  order: s,
  isFullWidthMobile: u = !1,
  span: h = 1,
  start: d = "auto",
  showDividers: y,
  className: x,
  ...b
}) => /* @__PURE__ */ m(
  "td",
  {
    style: {
      "--cellOrder": s,
      "--alignItems": f,
      "--justifyContent": l,
      "--span": h,
      "--start": d
    },
    className: C(
      n.tableCell,
      {
        [n.highlight]: a,
        [n[`highlight--${a}`]]: a,
        [n.fullWidthMobile]: u,
        [n.mainColumn]: c,
        [n.span]: h,
        [n.start]: d,
        [n.showDividers]: y
      },
      x
    ),
    ...b,
    children: /* @__PURE__ */ m("div", { className: n.cellWrapper, children: i })
  }
), S = ({
  children: l,
  label: i,
  mobileColumns: a,
  className: c,
  ...f
}) => {
  const s = $.Children.map(l, (u) => {
    var h;
    if (!(he.isFragment(u) && !((h = u.props) != null && h.children)))
      return u;
  });
  return /* @__PURE__ */ m("div", { "aria-label": i, className: n.grid, children: /* @__PURE__ */ m(
    "table",
    {
      style: {
        "--tableColumns": s == null ? void 0 : s.length,
        "--mobileColumns": a
      },
      className: C(n.table, c),
      ...f,
      children: l
    }
  ) });
}, Ze = ({
  children: l,
  label: i,
  className: a
}) => {
  const c = de(), f = $.Children.map(
    l,
    (s) => me(s) ? be(s, {
      "aria-labelledby": c
    }) : s
  );
  return /* @__PURE__ */ w("div", { className: C(n.tableGroup, a), children: [
    i && /* @__PURE__ */ m("h3", { className: n.tableLabel, id: c, children: i }),
    f
  ] });
};
S.Group = Ze;
S.Caption = qe;
S.Head = Ve;
S.Body = je;
S.Footer = Ge;
S.Row = ke;
S.Cell = Xe;
S.Column = Ue;
export {
  S as T
};
